import { MANAGER_ROLES, WORKSPACE_ROLES } from "./guide/articleRoles";

/**
 * "What's new", newest first. Add an entry at the top when something ships.
 *
 * {
 *    id: "help-center",           // unique
 *    date: "2026-10-05",          // YYYY-MM-DD
 *    tag: "New",                  // one of UPDATE_TAGS
 *    title: "A Help Center on every page",
 *    body: `Markdown`,            // links work as in the User Guide
 *    article: "survey-analytics", // optional: "Learn more" opens this article
 *    roles: [...]                 // optional: only these roles see it (guide/articleRoles.js)
 * }
 */
export const PRODUCT_UPDATES = [
   {
      id: "survey-colors",
      date: "2026-10-28",
      tag: "New",
      title: "Choose your survey's colors",
      body:
         "Open **Design Settings** in the survey builder and click **Edit colors** to pick one of 10 ready themes, like **Ocean**, **Emerald** or **Pink October**, or set the page, answer option and button colors yourself. Respondents see the new colors as soon as you click **Save colors**.",
      roles: MANAGER_ROLES
   },
   {
      id: "help-center",
      date: "2026-10-05",
      tag: "New",
      title: "A Help Center on every page",
      body:
         "Click **Help** at the top of any page to search the User Guide, see the articles for the page you're on, ask a question, or contact our team. Press **?** to open it from anywhere."
   },
   {
      id: "template-library-cards",
      date: "2026-09-15",
      tag: "Improved",
      title: "A new look for your templates",
      body:
         "**Template library** on the **Surveys** page now shows your saved templates as cards under **My templates**, with search and filters to find the one you need.",
      article: "survey-templates",
      roles: MANAGER_ROLES
   },
   {
      id: "survey-link-opens",
      date: "2026-08-31",
      tag: "New",
      title: "See who opened your survey link",
      body:
         "Open a send in **Automated Campaigns** to see **Who opened the link**: each recipient, the channel, how many times they opened it, when, and whether they submitted.",
      article: "send-campaign",
      roles: MANAGER_ROLES
   },
   {
      id: "ask-ai-survey-answers",
      date: "2026-08-31",
      tag: "New",
      title: "Ask AI about your survey's answers",
      body:
         "The **Ask AI** tab in **Survey Analytics** answers questions about a survey's submissions in your own words, like “Summarise the main findings” or “What themes come up in the open-text answers?”",
      article: "survey-analytics",
      roles: WORKSPACE_ROLES
   }
];

export const UPDATE_TAGS = ["New", "Improved", "Fixed"];

/** "2026-10-05" → "Oct 5, 2026", read as a local date so no timezone shifts the day. */
export const formatUpdateDate = (date) => {
   const [year, month, day] = date.split("-").map(Number);
   return new Date(year, month - 1, day).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
   });
};
